"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";

import worldMapImg from "@/../public/image/new-version/home/world_map.png";

const NAMESPACE = "new-spring-manufacturing";

const STATS = [
	{ valueKey: "globalNetworkStat1Value", labelKey: "globalNetworkStat1Label" },
	{ valueKey: "globalNetworkStat2Value", labelKey: "globalNetworkStat2Label" },
	{ valueKey: "globalNetworkStat3Value", labelKey: "globalNetworkStat3Label" },
	{ valueKey: "globalNetworkStat4Value", labelKey: "globalNetworkStat4Label" },
] as const;

export default function GlobalNetwork() {
	const t = useTranslations(NAMESPACE);

	return (
		<div className="sm:pt-10 md:pt-12 lg:pt-16">
			<section
				className="relative isolate overflow-hidden bg-[#ffffff] py-8 forced-color-adjust-none [color-scheme:light] sm:py-10 md:py-12 lg:py-16"
				style={{ colorScheme: "light" }}
			>
				<div className="pointer-events-none absolute inset-0 z-0 bg-[#ffffff]">
					<div className="container relative h-full min-h-[200px]">
						<Image
							src={worldMapImg}
							alt={t("globalNetworkMapImageAlt")}
							fill
							className="object-contain object-center opacity-60"
							sizes="(max-width: 640px) 100vw, (max-width: 768px) 640px, (max-width: 1024px) 768px, (max-width: 1280px) 1024px, 1280px"
						/>
					</div>
				</div>

				<div className="container relative z-10">
					<div className="space-y-8 sm:space-y-10 lg:space-y-12">
						<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
							<span className="block leading-[1.12]">{t("globalNetworkTitleLine1")}</span>
							<span className="mt-0.5 flex items-end gap-2.5 leading-[1.12] sm:gap-3">
								<span>{t("globalNetworkTitleLine2")}</span>
							</span>
						</h2>

						<div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between lg:gap-12 xl:gap-16">
							<div className="space-y-4 text-sm leading-relaxed text-black md:text-base lg:max-w-[40%] lg:shrink-0 xl:max-w-[42%]">
								<p>{t("globalNetworkDescription1")}</p>
								<p>{t("globalNetworkDescription2")}</p>
							</div>

							<div className="grid min-w-0 flex-1 grid-cols-2 gap-x-6 gap-y-8 sm:gap-x-8 lg:gap-x-12 xl:gap-x-16">
								{STATS.map((stat) => (
									<div key={stat.valueKey} className="text-center lg:text-left">
										<div className="mb-6 text-2xl font-bold text-themePrimary400 sm:text-3xl md:text-4xl lg:text-[42px]">
											{t(stat.valueKey)}
										</div>
										<div className="text-sm text-black md:text-base">{t(stat.labelKey)}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
